import React, { useCallback, useEffect, useState } from 'react'
import { Button, Form, Modal } from 'react-bootstrap'
import { DataspaceConnector } from '../../models/DataSpace'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';

type Props = {
  connector?: DataspaceConnector;
  onSubmit?: (connector: DataspaceConnector) => void;
  onCancel?: () => void;
}

export default function DataSpaceConnectorForm({ connector, onSubmit, onCancel }: Props) {
  const [editingConnector, setEditingConnector] = useState<DataspaceConnector>();
  const [validated, setValidated] = useState(false);

  useEffect(() => {
    setEditingConnector(connector);
  }, [connector]);

  const handleSubmit = useCallback((evt: React.FormEvent<HTMLFormElement>) => {
    const form = evt.currentTarget;
    evt.stopPropagation();
    evt.preventDefault();
    setValidated(true);

    if (form.checkValidity() === true) onSubmit?.(editingConnector!);
  }, [onSubmit, editingConnector]);

  const handleFieldChange = useCallback((evt: React.ChangeEvent<HTMLInputElement>) => {
    const field = evt.target.name;
    const value = evt.target.value;

    setEditingConnector(conn => ({
      ...conn!,
      [field]: value,
    }));
  }, []);

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit}>
      <Modal.Body>
        <Form.Group className="mb-3" controlId="connector-name">
          <Form.Label>Name</Form.Label>
          <Form.Control name="name" placeholder="Data Space Connector Name" size="sm" value={editingConnector?.name} onChange={handleFieldChange} required />
          <Form.Control.Feedback type="invalid">Data Space Connector name is required.</Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3" controlId="connector-description">
          <Form.Label>Description</Form.Label>
          <Form.Control as="textarea" rows={3} name="description" placeholder="Data Space Connector Description" size="sm" value={editingConnector?.description} onChange={handleFieldChange} />
        </Form.Group>

        <Form.Group className="mb-3" controlId="connector-connectorUrl">
          <Form.Label>Connector URL</Form.Label>
          <Form.Control name="connectorUrl" placeholder="Data Space Connector URL" size="sm" value={editingConnector?.connectorUrl} onChange={handleFieldChange} required />
          <Form.Control.Feedback type="invalid">Data Space Connector URL is required.</Form.Control.Feedback>
        </Form.Group>
      </Modal.Body>

      <Modal.Footer className="justify-content-between">
        <Button type="button" variant="light" size="sm" className="border" onClick={onCancel}>Close</Button>
        <Button type="submit" variant="success" size="sm">
          <FontAwesomeIcon icon={solid('save')} />
          <span className="ms-2">Save</span>
        </Button>
      </Modal.Footer>
    </Form>
  )
}